import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, DatePicker, Form, Input, Modal, Select } from "antd"
import TextArea from "antd/es/input/TextArea";
import { useEffect, useMemo } from "react";
import { getAllKeyGroupsQuery } from "../../util/query/keyRegister.query";
import { debounce } from "lodash";
import { CaretDownFilled } from "@ant-design/icons";
import { getCustomerBySiteId } from "../../util/query/customer.query";

export const KeyActionModal = ({visible, close, type, handleActionSubmit, loading, record}) => {

    const [form] = Form.useForm();

    useEffect(() => {
        if (type) {
            getActionModalTitle(type);
            form.resetFields();
        }
    }, [type]);

    const {data: customerData, loading: customerDataLoading} = useQuery(getCustomerBySiteId,{
        variables:{
            siteId: record?.siteId,
        },
        skip: !record?.siteId,
        fetchPolicy: 'network-only'
    });


    const [getKeyGroup, {data:AllKeyGroupsData, loading:allKeyGropDataLoading}] = useLazyQuery(getAllKeyGroupsQuery,{
        variables:{
            input:{
                // filter: null,
                search: null,
                pageSize: 1000,
                page: 1
            },
            fetchPolicy: 'network-only'
        }
    });

    const debouncedGetKeyGroups = useMemo(
        () =>
            debounce((searchTerm) => {
                getKeyGroup({
                    variables:{
                        input:{
                            // filter: null,
                            search: searchTerm,
                            pageSize: 1000,
                            page: 1
                        },
                        fetchPolicy: 'network-only'
                    }
                });
            }, 300),
        []
    );



    const getActionModalTitle = (type) => {
        const titles = {
            'Assign Key': 'Assign Key to Person/Team',
            'Move Key Group': 'Move Key to Different Group',
            'Add To Group': 'Add To Key Group',
            'Request Return': 'Request Key Return',
            'Return to Customer': 'Return Key to Customer',
            'Report Lost': 'Report Key as Lost',
            'Audit Request': 'Audit Request',
            'Mark as Found': 'Mark as Found'
        };
        return titles[type] || type;
    };

    const renderActionForm = () => {
        switch (type) {
            
            case 'Mark as found':
                return (
                    <>
                        <Form.Item
                            name="foundDate"
                            label="Date Found"
                            rules={[{ required: true, message: 'Please select date found' }]}
                        >
                            <DatePicker format={"DD/MM/YYYY"} style={{ width: '100%' }} className="generic-input-control" />
                        </Form.Item>
                        <Form.Item
                            name="foundLocation"
                            label="Found Location"
                            rules={[{ required: true, message: 'Please provide where the key was found' }]}
                        >
                            <Input placeholder="Enter location where key was found" className="generic-input-control" />
                        </Form.Item>
                        <Form.Item
                            name="foundNotes"
                            label="Notes"
                        >
                            <TextArea rows={3} placeholder="Additional details about how the key was found" className="generic-input-control" />
                        </Form.Item>
                    </>
                );

            case 'Move Key Group':
                return (
                    <>
                        <Form.Item
                            name="groupId"
                            label="Target Key Group"
                            rules={[{ required: true, message: 'Please select target key group' }]}
                        >
                            <Select 
                                placeholder="Select key group" 
                                className="custom-select"
                                onSearch={debouncedGetKeyGroups}
                                filterOption={false}
                                showSearch
                                suffixIcon={<CaretDownFilled/>}
                            >
                                {allKeyGropDataLoading?

                                    <Select.Option disabled hidden>Loading ...</Select.Option>
:
                                    AllKeyGroupsData?.getKeyGroups?.response?.map((group)=>(

                                        <Select.Option value={group?._id}>{group?.name}</Select.Option>
                                    ))
                                }
                            </Select>
                        </Form.Item>
                    </>
                );


            case 'Add To Group':
                return (
                    <>
                        <Form.Item
                            name="groupId"
                            label="Target Key Group"
                            rules={[{ required: true, message: 'Please select target key group' }]}
                        >
                            <Select 
                                placeholder="Select key group" 
                                className="custom-select"
                                onSearch={debouncedGetKeyGroups}
                                filterOption={false}
                                showSearch
                                suffixIcon={<CaretDownFilled/>}

                            >
                                {allKeyGropDataLoading?

                                    <Select.Option disabled hidden>Loading ...</Select.Option>
:
                                    AllKeyGroupsData?.getKeyGroups?.response?.map((group)=>(

                                        <Select.Option value={group?._id}>{group?.name}</Select.Option>
                                    ))
                                }
                            </Select>
                        </Form.Item>
                    </>
                );

            case 'Request Return':
                return (
                    <>
                        <Form.Item
                            name="returnRequestExpectedDate"
                            label="Expected Return Date"
                            rules={[{ required: true, message: 'Please select return date' }]}
                        >
                            <DatePicker format={"DD/MM/YYYY"}  style={{ width: '100%' }} className="generic-input-control"/>
                        </Form.Item>
                       
                        <Form.Item
                            name="returnRequestNotes"
                            label="Notes"
                            rules={[{ required: true, message: 'Please select return method' }]}

                        >
                            <TextArea rows={3} placeholder="Additional notes" className="generic-input-control" />
                        </Form.Item>
                    </>
                );

            case 'Return to Customer':
                return (
                    <>
                        <Form.Item
                            label={"Customer Name"}
                        >
                            <Input disabled className="generic-input-control" value={customerData?.getCustomerBySiteId?.response?.customername}/>
                        </Form.Item>
                        
                     


                        <Form.Item
                            name="returnDate"
                            label="Return Date"
                            rules={[{ required: true, message: 'Please enter return date' }]}
                        >
                            <DatePicker
                                placeholder="Return Date"
                                className="generic-input-control"
                                format={"DD/MM/YYYY"}
                            />
                        </Form.Item>
                        <Form.Item
                            name="returnMethod"
                            label="Return Method"
                            rules={[{ required: true, message: 'Please select return method' }]}
                        >
                            <Select placeholder="Select return method" className="custom-select">
                                <Select.Option value="pickup">Customer Pickup</Select.Option>
                                <Select.Option value="delivery">Delivery</Select.Option>
                                <Select.Option value="mail">Mail</Select.Option>
                            </Select>
                        </Form.Item>
                        <Form.Item
                            name="returnNotes"
                            label="Return Notes"
                            rules={[{ required: true, message: 'Please enter return notes' }]}

                        >
                            <TextArea rows={3} placeholder="Return instructions or notes" className="generic-input-control" />
                        </Form.Item>
                    </>
                );

            case 'Report Lost':
                return (
                    <>
                        <Form.Item
                            name="lostDate"
                            label="Date Lost"
                            rules={[{ required: true, message: 'Please select when key was lost' }]}
                        >
                            <DatePicker style={{ width: '100%' }} 
                                format={"DD/MM/YYYY"}
                            
                            className="generic-input-control" />
                        </Form.Item>
                        <Form.Item
                            name="lastLostLocation"
                            label="Last Known Location"
                            rules={[{ required: true, message: 'Please provide last known location' }]}
                        >
                            <Input placeholder="Enter last known location" className="generic-input-control" />
                        </Form.Item>
                        <Form.Item
                            name="lostNotes"
                            label="Circumstances"
                            rules={[{ required: true, message: 'Please describe circumstances' }]}
                        >
                            <TextArea rows={4} placeholder="Describe how the key was lost" className="generic-input-control" />
                        </Form.Item>
                        <Form.Item
                            name="lostReportedBy"
                            label="Reported By"
                            rules={[{ required: true, message: 'Please select who reported it' }]}
                        >
                            <Input placeholder="Who reported it?" className={"generic-input-control"} />
                        </Form.Item>
                    </>
                );

            case 'Audit Request':
                return (
                    <>
                        <Form.Item
                            name="expectedAuditDate"
                            label="Expected Date"
                            rules={[{ required: true, message: 'Please select audit type' }]}
                        >
                            <DatePicker 
                                className="generic-input-control"
                                placeholder="Expected Audit Date"
                                format={"DD/MM/YYYY"}
                            />
                        </Form.Item>

                        <Form.Item
                            name="auditNotes"
                            label="Audit Reason"
                            rules={[{ required: true, message: 'Please provide audit reason' }]}
                        >
                            <TextArea rows={3} placeholder="Reason for audit request" className="generic-input-control" />
                        </Form.Item>
                    </>
                );
            
            case 'Returned':
                return (
                    <>
                        <Form.Item
                            name="returnDate"
                            label="Return Date"
                            rules={[{ required: true, message: 'Please select return date' }]}
                        >
                            <DatePicker
                            format={"DD/MM/YYYY"}
                            
                            className="generic-input-control" />
                        </Form.Item>
                        {/* <Form.Item
                            name="condition"
                            label="Condition"
                            rules={[{ required: true, message: 'Please select condition' }]}
                        >
                            <Select placeholder="Select condition" className="custom-select">
                                <Select.Option value="good">Good</Select.Option>
                                <Select.Option value="damaged">Damaged</Select.Option>
                            </Select>
                        </Form.Item> */}
                    </>
                );

            default:
                return null;
        }
    };

    return(
        <Modal
            visible={visible}
            width={600}
            confirmLoading={loading}
            closable={false}
            footer={
                <div className="drawer-footer" style={{display:'flex',  justifyContent:'flex-end', gap:'10px'}}>
                    <button className="drawer-filled-btn" onClick={() => handleActionSubmit(type, form, customerData?.getCustomerBySiteId?.response?._id || null)}>Submit</button>
                    <button onClick={close} className="drawer-outlined-btn">Cancel</button>
                </div>
            }
        >
            
            {/* Header */}
            <div className='modal-header-title'>
                <span style={{letterSpacing:'0.2px'}}> {getActionModalTitle(type)} </span>
                <span  onClick={close}><FontAwesomeIcon className='close' icon={faClose}/></span>
            </div>

            <div className='modal-body'>
                <Form
                    form={form}
                    layout="vertical"
                    name="actionForm"
                    requiredMark={false}
                    disabled={loading}
                >
                    {renderActionForm()}
                </Form>
            </div>

        </Modal>
    )
}